/** TEXTALIGNTYP — horizontal-vertical text box alignment (ST/OG/PSL TextAlign). */
export const LINE_TEXT_ALIGNS: string[] = [
  'LEFT-TOP',
  'CENTER-TOP',
  'RIGHT-TOP',
  'LEFT-MIDDLE',
  'CENTER-MIDDLE',
  'RIGHT-MIDDLE',
  'LEFT-BOTTOM',
  'CENTER-BOTTOM',
  'RIGHT-BOTTOM',
];
